import React from "react"
import { Link } from "gatsby"
import PropTypes from "prop-types"

import logo from "../images/Klaus-logo.png"

const Logo = ({ siteTitle }) => (
  <>
    <div className="navbar-brand level-left pl-3">
      <Link className="navbar-item level-item" to="/">
        <figure className="is-link logo">
          <img src={logo} alt={siteTitle} />
        </figure>
        <div>
          <h1 className="logo-font has-text-white has-text-weight-normal is-flex text-shadow">
            Architekten Innenarchitekten AG
          </h1>
        </div>
      </Link>
    </div>
  </>
)

Logo.propTypes = {
  siteTitle: PropTypes.string,
}

Logo.defaultProps = {
  siteTitle: `Klaus Architekten Innenarchitekten AG`,
}

export default Logo
